import React from "react";
import FunctionDefinedComponents, {RolledChildType} from "../handler-components/FunctionDefinedComponents";
import {threeDigitsSep} from "../../helpers";
import {OrderContextValues} from "../../contexts/OrderContext";
import * as DocumentPicker from "expo-document-picker";

interface state {
    receiptFile: File | undefined,
}

interface props {
    orderContext: OrderContextValues,
    children: any
}

export default class CTCReceiptComponents extends FunctionDefinedComponents <props, state> {

    constructor(props: any) {
        super(props);
        this.state = {
            receiptFile: undefined
        }
    }

    pick() {
        DocumentPicker.getDocumentAsync({
            type: "image/JPEG",
            multiple: false
        }).then(result => {
            if (result.type != "success")
                return;
            this.setState({
                receiptFile: result.file
            })
        });
    }

    save() {
        this.props.orderContext.sendCtcReceipt(this.state.receiptFile);
    }

    cancel() {
        this.props.orderContext.cancel();
    }

    rolledChildren(): RolledChildType {
        return [
            {
                role: "card-view",
                visible: true,
                props: {
                    card: this.props.orderContext.order?.cardToPay ?? null
                },
                children: null
            },
            {
                role: "description-text",
                visible: true,
                props: {},
                children: "توجه داشته باشید که پس از پرداخت به اینجا بازگردید و پایان یافتن عملیات کارت به کارت را با دکمه زیر تأیید کنید، در غیر اینصورت رستوران سفارش را تأیید و پردازش نخواهد کرد"
            },
            {
                role: "price-text",
                visible: true,
                props: {},
                children: `${threeDigitsSep((this.props.orderContext.order?.totalPayablePrice ?? 0) * 10)} ریال`
            },
            {
                role: "receipt-pressable",
                visible: true,
                props: {
                    onPress: () => {
                        this.pick();
                    },
                    receiptFile: this.state.receiptFile
                },
                children: null
            },
            {
                role: "button-save",
                visible: true,
                props: {
                    title: "ثبت پرداخت",
                    onPress: () => {
                        this.save();
                    }
                },
                children: null,
            },
            {
                role: "button-cancel",
                visible: true,
                props: {
                    title: "از سفارش منصرف شدم",
                    onPress: () => {
                        this.cancel();
                    }
                },
                children: null,
            },
        ];
    }

}
